import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ActionSheetController, AlertController } from '@ionic/angular';
import { appConfig } from 'src/app/config/app.config';
import { Employee } from 'src/app/models/Employees';
import { Relative } from 'src/app/models/Relative';
import { ParamService } from 'src/app/services/param.service';
import { BackEndService } from 'src/app/services/backEnd.service';
import { AlertService } from 'src/app/util/alert.service';
import { UtilityService } from 'src/app/util/utility.service';

@Component({
  selector: 'app-circle',
  templateUrl: './circle.component.html',
  styleUrls: ['./circle.component.scss'],
})
export class CircleComponent implements OnInit {

  relativeList: Relative[] = [];
  mother: Relative[] = [];
  father: Relative[] = [];
  brother: Relative[] = [];
  sister: Relative[] = [];
  daughter: Relative[] = [];
  son: Relative[] = [];
  husband: Relative[] = [];
  wife: Relative[] = [];
  @Input() emp: Employee = new Employee;
  @Output() clickCenter: EventEmitter<null> = new EventEmitter();
  @Output() empChange: EventEmitter<Employee> = new EventEmitter();
  utilityService: UtilityService = new UtilityService();
  constructor(public crudService: BackEndService,
    private actionSheetController: ActionSheetController,
    private alertService: AlertService,
    private paramService: ParamService,
    private alertController: AlertController,
    private router: Router) { }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (this.emp) {
      this.setRelation();
    }
  }

  setRelation() {
    this.crudService.searchObject(appConfig.STORAGE_TABLE.Relative, [["emp_id", this.emp.id]]).then((relativeList: Relative[]) => {
      this.relativeList = relativeList;
      this.mother = relativeList.filter(x => x.relation == appConfig.Relation.Mother);
      this.father = relativeList.filter(x => x.relation == appConfig.Relation.Father);
      this.brother = relativeList.filter(x => x.relation == appConfig.Relation.Brother);
      this.sister = relativeList.filter(x => x.relation == appConfig.Relation.Sister);
      this.daughter = relativeList.filter(x => x.relation == appConfig.Relation.Daughter);
      this.son = relativeList.filter(x => x.relation == appConfig.Relation.Son);
      this.wife = relativeList.filter(x => x.relation == appConfig.Relation.Wife);
      this.husband = relativeList.filter(x => x.relation == appConfig.Relation.Husband);


      this.getDefault();
    })
  }

  getDefault() {

    this.setDefault(this.mother, appConfig.Relation.Mother);
    this.setDefault(this.father, appConfig.Relation.Father);
    this.setDefault(this.brother, appConfig.Relation.Brother);
    this.setDefault(this.sister, appConfig.Relation.Sister);
    this.setDefault(this.daughter, appConfig.Relation.Daughter);
    this.setDefault(this.son, appConfig.Relation.Son);
    if (this.emp.user.gender == this.utilityService.genderList[0]) {
      this.setDefault(this.wife, appConfig.Relation.Wife);
    } else {
      this.setDefault(this.husband, appConfig.Relation.Husband);
    }
  }

  setDefault(array, relation) {
    if (array.length == 0) {
      if (this.emp[relation] != "Removed") {
        array.push({ relation: relation });
      }

    }
  }

  clickRel(rel: Relative) {
    console.log(rel)
    if (rel.id) {
      this.crudService.getObjectById(appConfig.STORAGE_TABLE.EMPLOYEE, rel.relative_id).then((emp: Employee) => {
        this.emp = emp;
        this.empChange.emit(emp);
        this.setRelation();
      })
      // this.paramService.setData(appConfig.STORAGE_TABLE.EMPLOYEE, this.emp);
      // this.paramService.setData(appConfig.STORAGE_TABLE.Relative, rel);
      // this.router.navigate(["/user-edit/" + rel.relative_id]);
    } else {
      this.presentAlert(rel);
    }
  }


  async presentAlert(rel: Relative) {
    let phoneNumber;
    const alert = await this.alertController.create({
      header: "Phone Number",
      message: "With phone you can avoid duplicate records and we will make sure your number will be hidden.",
      inputs: [
        {
          name: "phoneNumber",
          placeholder: rel.relation + " Phone",
          type: 'number',
          value: phoneNumber
        }],
      buttons: [
        {
          text: "Add with Phone",
          handler: (alertData) => { //takes the data
            console.log(alertData["phoneNumber"])
            // this.crudService.searchObject()
            this.navigateUserEdit(rel, null);
            return true;
          }
        },
        {
          text: "Add Without Phone",
          cssClass: 'secondary',
          handler: () => {
            this.navigateUserEdit(rel, null);
            return true;
          }
        },
        {
          text: "Remove " + rel.relation,
          cssClass: 'secondary',
          handler: () => {
            this.emp[rel.relation] = "Removed";
            this.crudService.saveObject(appConfig.STORAGE_TABLE.EMPLOYEE, this.emp).then(() => {
              this.getDefault();
            });
            return true;
          }
        }, {
          text: "Don't add " + rel.relation,
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
            return true;
          }
        }
      ]
    });

    await alert.present();
  }
  navigateUserEdit(rel: Relative, id) {
    this.paramService.setData(appConfig.STORAGE_TABLE.EMPLOYEE, this.emp);
    this.paramService.setData(appConfig.STORAGE_TABLE.Relative, rel);
    this.paramService.setData("relativeList", this.relativeList);
    if (id) {
      this.router.navigate(["/user-edit/" + id]);
    } else {
      this.router.navigate(["/user-edit"]);
    }

  }
}
